import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getTransactions, getTransactionStats } from "../../store/transaction/transaction.action";
import Pagination from "../../extra/Pagination";
import dayjs from "dayjs";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import formatImageUrl from "../../extra/functions";
import defaultImage from "../../../assets/images/default.jpg";

const TransactionHistory = () => {
  const dispatch = useDispatch();
  const { transactions, pagination, stats } = useSelector((state) => state.transaction);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [type, setType] = useState("all");
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  useEffect(() => {
    dispatch(getTransactions(currentPage, rowsPerPage, type, status, startDate, endDate, search));
  }, [dispatch, currentPage, rowsPerPage, type, status, startDate, endDate]);

  useEffect(() => {
    dispatch(getTransactionStats(startDate, endDate));
  }, [dispatch, startDate, endDate]);

  const handleSearch = () => {
    setCurrentPage(1);
    dispatch(getTransactions(1, rowsPerPage, type, status, startDate, endDate, search));
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event), 10);
    setCurrentPage(1);
  };

  const handleApply = (event, picker) => {
    const dayStart = dayjs(picker.startDate).format("YYYY-MM-DD");
    const dayEnd = dayjs(picker.endDate).format("YYYY-MM-DD");
    setStartDate(dayStart);
    setEndDate(dayEnd);
    setCurrentPage(1);
  };

  const handleCancel = (event, picker) => {
    picker.element.val("");
    setStartDate("All");
    setEndDate("All");
    setCurrentPage(1);
  };

  const getTransactionTypeLabel = (transactionType) => {
    switch (transactionType) {
      case "PRODUCT_PURCHASE":
        return { label: "Product Purchase", color: "#3B82F6", bg: "#EBF5FF" };
      case "GIFT_PURCHASE":
        return { label: "Gift Purchase", color: "#8B5CF6", bg: "#F3E8FF" };
      case "COIN_PURCHASE":
        return { label: "Coin Purchase", color: "#F59E0B", bg: "#FEF3C7" };
      default:
        return { label: transactionType, color: "#6B7280", bg: "#F3F4F6" };
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "completed":
        return { label: "Completed", color: "#10B981", bg: "#D1FAE5" };
      case "pending":
        return { label: "Pending", color: "#F59E0B", bg: "#FEF3C7" };
      case "failed":
        return { label: "Failed", color: "#EF4444", bg: "#FEE2E2" };
      case "refunded":
        return { label: "Refunded", color: "#6366F1", bg: "#E0E7FF" };
      default:
        return { label: status, color: "#6B7280", bg: "#F3F4F6" };
    }
  };

  return (
    <div className="mainSellerTable">
      <div className="sellerTable">
        <div className="col-12 headname">Transaction History</div>

        {/* Stats Cards */}
        <div className="row mx-2 mb-3">
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #EBF5FF)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Total Transactions</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>{stats?.totalCount || 0}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #D1FAE5)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Total Revenue (USD)</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>${parseFloat(stats?.productPurchases?.revenue || 0).toFixed(2)}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #F3E8FF)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Total Coins Spent</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>{stats?.totalAmountCoins || 0}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #FEF3C7)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Completed</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>{stats?.completedCount || 0}</h3>
            </div>
          </div>
        </div>

        <div className="sellerMain">
          <div className="tableMain">
            <div className="sellerHeader primeHeader">
              <div className="row align-items-center">
                {/* Type Filter */}
                <div className="col-xl-2 col-md-3 col-6 mb-2">
                  <select
                    className="form-select"
                    value={type}
                    onChange={(e) => { setType(e.target.value); setCurrentPage(1); }}
                    style={{ borderRadius: "5px", padding: "8px" }}
                  >
                    <option value="all">All Types</option>
                    <option value="PRODUCT_PURCHASE">Product Purchase</option>
                    <option value="GIFT_PURCHASE">Gift Purchase</option>
                    <option value="COIN_PURCHASE">Coin Purchase</option>
                  </select>
                </div>

                {/* Status Filter */}
                <div className="col-xl-2 col-md-3 col-6 mb-2">
                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => { setStatus(e.target.value); setCurrentPage(1); }}
                    style={{ borderRadius: "5px", padding: "8px" }}
                  >
                    <option value="all">All Status</option>
                    <option value="completed">Completed</option>
                    <option value="pending">Pending</option>
                    <option value="failed">Failed</option>
                    <option value="refunded">Refunded</option>
                  </select>
                </div>

                {/* Date Range */}
                <div className="col-xl-3 col-md-3 col-6 mb-2">
                  <DateRangePicker
                    initialSettings={{
                      autoUpdateInput: false,
                      locale: { cancelLabel: "Clear" },
                      maxDate: new Date(),
                    }}
                    onApply={handleApply}
                    onCancel={handleCancel}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Select Date Range"
                      readOnly
                      style={{ cursor: "pointer", padding: "8px" }}
                    />
                  </DateRangePicker>
                </div>

                {/* Search */}
                <div className="col-xl-5 col-md-3 col-6 mb-2">
                  <div className="d-flex">
                    <input
                      type="text"
                      className="form-control me-2"
                      placeholder="Search by name, ID..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      style={{ padding: "8px" }}
                    />
                    <button
                      className="btn"
                      onClick={handleSearch}
                      style={{ background: "#B93160", color: "#fff", padding: "8px 20px" }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="primeMain">
              <table width="100%" className="primeTable text-center" style={{ maxHeight: "600px" }}>
                <thead className="sticky-top" style={{ top: "-1px", zIndex: "1" }}>
                  <tr>
                    <th className="fw-bold py-3">No</th>
                    <th className="fw-bold py-3">Date & Time</th>
                    <th className="fw-bold py-3">Type</th>
                    <th className="fw-bold py-3">User</th>
                    <th className="fw-bold py-3">Item</th>
                    <th className="fw-bold py-3">Amount</th>
                    <th className="fw-bold py-3">Payment Method</th>
                    <th className="fw-bold py-3">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions?.length > 0 ? (
                    transactions.map((txn, index) => {
                      const typeInfo = getTransactionTypeLabel(txn.transactionType);
                      const statusInfo = getStatusLabel(txn.status);
                      return (
                        <tr key={txn._id}>
                          <td className="text-white py-3">
                            {(currentPage - 1) * rowsPerPage + index + 1}
                          </td>
                          <td className="text-white py-3">
                            <div>
                              <span>{dayjs(txn.createdAt).format("DD MMM YYYY")}</span>
                              <br />
                              <small style={{ color: "#9CA3AF" }}>{dayjs(txn.createdAt).format("hh:mm A")}</small>
                            </div>
                          </td>
                          <td className="py-3">
                            <span
                              className="px-3 py-1"
                              style={{
                                backgroundColor: typeInfo.bg,
                                color: typeInfo.color,
                                borderRadius: "20px",
                                fontSize: "12px",
                                fontWeight: "500",
                                whiteSpace: "nowrap"
                              }}
                            >
                              {typeInfo.label}
                            </span>
                          </td>
                          <td className="text-white py-3">
                            <div>
                              <span className="fw-medium">{txn.userName || "User"}</span>
                              {txn.userUniqueId && (
                                <>
                                  <br />
                                  <small style={{ color: "#9CA3AF" }}>ID: {txn.userUniqueId}</small>
                                </>
                              )}
                            </div>
                          </td>
                          <td className="py-3">
                            <div className="d-flex align-items-center justify-content-center">
                              {txn.itemImage && (
                                <img
                                  src={formatImageUrl(txn.itemImage)}
                                  width={40}
                                  height={40}
                                  style={{ borderRadius: "8px", marginRight: "10px", objectFit: "cover" }}
                                  alt=""
                                  onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
                                />
                              )}
                              <div className="text-start">
                                <span className="text-white">{txn.itemName || "-"}</span>
                                {txn.itemQuantity > 1 && (
                                  <>
                                    <br />
                                    <small style={{ color: "#9CA3AF" }}>Qty: {txn.itemQuantity}</small>
                                  </>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="text-white py-3">
                            <span className="fw-bold">
                              {txn.currency === "COINS" ? (
                                <>{txn.amount} Coins</>
                              ) : (
                                <>GH{parseFloat(txn.amount).toFixed(2)}</>
                              )}
                            </span>
                          </td>
                          <td className="text-white py-3">
                            {txn.paymentMethod || "-"}
                          </td>
                          <td className="py-3">
                            <span
                              className="px-3 py-1"
                              style={{
                                backgroundColor: statusInfo.bg,
                                color: statusInfo.color,
                                borderRadius: "20px",
                                fontSize: "12px",
                                fontWeight: "500"
                              }}
                            >
                              {statusInfo.label}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-white py-5">
                        No Transactions Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Pagination
              component="div"
              count={pagination.total}
              totalData={pagination.total}
              type={"server"}
              onPageChange={handleChangePage}
              serverPerPage={rowsPerPage}
              serverPage={currentPage}
              setCurrentPage={setCurrentPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { getTransactions, getTransactionStats })(TransactionHistory);
